import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IConversationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IConversationResponseInstance'
import {mapMessageResponseInstance} from '@toolify/client/src/modules/api/singletons/mapMessageResponseInstance'

export function mapConversationResponseInstance(conversation: IToJson<IConversationResponseInstance>): IConversationResponseInstance {
  return {
    ...conversation,
    latestMessage: conversation.latestMessage ? mapMessageResponseInstance(conversation.latestMessage) : null,
  } as IConversationResponseInstance // TODO: TS: Remove "as ..."
}

